(function($) { 

    $(document).ready(function () {


        // $('.main_menu li .parent_link').each(function(index, element) {
        //     var menuItemText = $(element).text();
        //     if (menuItemText.indexOf('Runout Clearance') !== -1) {
        //        $(element).addClass('yellow');
        //     }
        //  });

        $(window).scroll(function() {
            if ($(this).scrollTop() > 1) {
                $('.header-wrapper').addClass("sticky_header");
            } else {
                $('.header-wrapper').removeClass("sticky_header");
            }
        });

        $(".hover_btn").on("click", function() {
            $(".hover_content").toggleClass("active");
            $(this).toggleClass("active");
        });

        $(window).scroll(function() {
            if ($(this).scrollTop() > 100) {
                $('.scrollup').fadeIn();
            } else {
                $('.scrollup').fadeOut();
            }
        });
        $('.scrollup').click(function() {
            $("html, body").animate({
                scrollTop: 0
            }, 600);
            return false;
        });

    

    });

})(jQuery);